import PhoneNumber from 'awesome-phonenumber'
import { MobileMeta, mobileCountries } from '../../../../../common/mobileData'
import { countries, Country } from '../../../../../common/countryData'

export const findNationality = (nationalityCode?: string | null): Country | null => {
  if (!nationalityCode) {
    return null
  }

  return (
    countries.find(({ identifiers }) =>
      identifiers.some(
        identifier => identifier.toLowerCase() === nationalityCode.toLowerCase(),
      ),
    ) ?? null
  )
}

export const findMobileMeta = (iso2: string) =>
  mobileCountries.find(country => country.iso2 === iso2.toUpperCase())

export const DEFAULT_MOBILE_META = findMobileMeta('GB') as MobileMeta

const getInitialMobileMeta = (phone: string): MobileMeta => {
  if (phone[0] === '+') {
    const regionCode = new PhoneNumber(phone).getRegionCode()
    const country = regionCode ? findMobileMeta(regionCode) : undefined

    if (country !== undefined) {
      return country
    }
  }

  return DEFAULT_MOBILE_META
}

// Like the Vue modal's DateInput: a prefilled date is sent in the same format as a date the user enters
export const getInitialDob = (dob?: string) => {
  const date = new Date(dob ?? '')

  return Number.isNaN(date.getTime())
    ? dob
    : new Date(
        Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()),
      ).toISOString()
}

export const getInitialMobileValues = (
  mobile?: string,
): { mobile: string; mobileMeta: MobileMeta } => {
  const phone = mobile?.trim() ?? ''
  const mobileMeta = getInitialMobileMeta(phone)

  if (phone === '') {
    return { mobile: '', mobileMeta }
  }

  const phoneNumber = new PhoneNumber(phone, mobileMeta.iso2)

  return {
    mobile: phoneNumber.getNumber('e164') ?? '',
    mobileMeta,
  }
}
